import { Box } from '@mui/material';
import { ClientListProps } from 'model/client.model';
import { LayoutType } from 'model/deals.model';
import ClientColumnGrid from './ClientColumnGrid';
import ClientRowGrid from './ClientRowGrid';
import GroupedClientsList from './GroupedClientsList';

const ClientsList = ({
  layout,
  category,
  data,
  loading,
  groupedSelected,
  groupedData,
  pagination,
  infiniteScroll,
  onSort,
}: ClientListProps) => {
  if (groupedSelected) {
    return (
      <Box>
        <GroupedClientsList
          groupedData={groupedData}
          loading={loading}
          layout={layout}
          pagination={layout === LayoutType.LIST ? pagination : undefined}
          infiniteScroll={layout === LayoutType.KANBAN ? infiniteScroll : undefined}
          onSort={onSort}
        />
      </Box>
    );
  }

  if (layout === LayoutType.KANBAN) {
    return (
      <Box>
        <ClientColumnGrid
          clients={data}
          category={category}
          loading={loading}
          infiniteScroll={infiniteScroll}
        />
      </Box>
    );
  }

  return (
    <Box>
      <ClientRowGrid
        clients={data}
        category={category}
        loading={loading}
        pagination={pagination}
        onSort={onSort}
      />
    </Box>
  );
};

export default ClientsList;
